import { BaseFormInsertProps, BaseFormUpdateProps, FormInsertData } from "@boilerplate/types/entity";
import LoggedHourEntity from ".";
import LoggedHourBaseInsertForm from "@/_base/loggedHour/components/LoggedHourBaseInsertForm";
import { useMemo } from "react";
import { useAuthenticatedUserStore } from "@/stores/UserStore";
import LoggedHourBaseUpdateForm from "@/_base/loggedHour/components/LoggedHourBaseUpdateForm";

function LoggedHourUpdateForm({ formOnly = false, onClose, Entity = LoggedHourEntity, id: propId, ...props }: BaseFormUpdateProps<typeof LoggedHourEntity.model>) {
    const currentUser = useAuthenticatedUserStore();
    const hiddenFields: (keyof FormInsertData<typeof LoggedHourEntity.model>)[] = useMemo(() => {
        if (currentUser.isSuperAdmin) {
          return [];
        }
    
        return ['createdAt', 'updatedAt'];
      }, [currentUser.isSuperAdmin]);

    return <LoggedHourBaseUpdateForm {...props} onClose={onClose} Entity={Entity} formOnly={formOnly} id={propId} hiddenFields={hiddenFields} />;
}

export default LoggedHourUpdateForm;